/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * UIAlert.tsx
 */

import React from "react";
import ReactDOM from "react-dom";
import Translation from "../../../services/translation/Translation";

const DEFAULT_ALERT_CONTAINER_ID = '#alert-container';

export default class UIAlert {
    private readonly _container: Element;
    private _component?: JSX.Element;

    constructor(container: Element) {
        this._container = container;
    }

    /**
     * default
     * @returns {UIAlert}
     */
    public static get default() {
        const element = document.querySelector(DEFAULT_ALERT_CONTAINER_ID);
        if (!element) {
            throw new Error('Error: default alert container Id is not defined');
        }

        return new UIAlert(element);
    }

    /**
     * dismiss
     * @param e
     */
    public dismiss = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        ReactDOM.unmountComponentAtNode(this._container);
    };

    /**
     * show
     * @param text
     * @return {Promise<boolean>}
     * @param t
     */
    public show(t: Translation, text: string): Promise<boolean> {
        return new Promise((resolve) => {
            this._component = this._generateAlert(t, text, resolve);
            ReactDOM.render(this._component, this._container);
        })
    }

    /**
     * _generateAlert
     * @param t
     * @param text
     * @param callback
     * @return {any}
     */
    private _generateAlert(t: Translation, text: string, callback: Function): JSX.Element {
        return <div className="ui-alert modal is-active">
            <div className="modal-background"/>
            <div className="modal-content">
                {text}
                <div className="alert-buttons">
                    <button className='button is-small' onClick={(e) => {
                        this.dismiss(e);
                        callback(true)
                    }}>{t.alertOk}
                    </button>
                    <button className='button is-light is-small' onClick={(e) => {
                        this.dismiss(e);
                        callback(false)
                    }}>{t.alertCancel}
                    </button>
                </div>
            </div>
        </div>
    }
}